/* eslint-disable react/require-default-props */
import React from 'react';
import {ScrollView} from 'react-native';
import {noop} from 'lodash';

import HealthJourney from '../HealthJouney';
import HealthProfile from '../HealthProfile';

import {styles} from './ClientHealthJourneyTab.style';

interface ClientHealthJourneyTabProps {
  onShowInfoPopover?: () => void;
  mwlData?: {};
  clientId?: '';
}

export const ClientHealthJourneyTab: React.FC<ClientHealthJourneyTabProps> = ({
  onShowInfoPopover = noop,
  mwlData = {},
  clientId = '',
}) => {
  return (
    <ScrollView style={styles.content}>
      <HealthProfile clientId={clientId} mwlData={mwlData} />
      <HealthJourney
        onShowInfoPopover={onShowInfoPopover}
        mwlData={mwlData}
        clientId={clientId}
      />
    </ScrollView>
  );
};

export default ClientHealthJourneyTab;
